if(!customElements.get('product-card')) {
  customElements.define('product-card', class extends HTMLElement {
    constructor() {
      super();
      
      this.fetchUrl = this.getAttribute('data-fetch-url');
    }

    getProductCardTemplate() {
      fetch(this.fetchUrl)
        .then(response => response.text())
        .then(html => {
          const fullCardContent = document.createElement('div');
          fullCardContent.innerHTML = html;

          // updates card top inner - with fail-safe checks
          const currentCardContent = this.querySelector('.card__inner .card__content');
          const newCardContent = fullCardContent.querySelector('.card__inner .card__content');
          if (currentCardContent && newCardContent) {
            currentCardContent.innerHTML = newCardContent.innerHTML;
          }

          const currentQuickAdd = this.querySelector('.card__inner .quick-add');
          const newQuickAdd = fullCardContent.querySelector('.card__inner .quick-add');
          if (currentQuickAdd && newQuickAdd) {
            currentQuickAdd.innerHTML = newQuickAdd.innerHTML;
          }

          // updates main content - with fail-safe checks
          const currentProductContent = this.querySelector('.card-product__content');
          const newProductContent = fullCardContent.querySelector('.card-product__content');
          if (currentProductContent && newProductContent) {
            currentProductContent.innerHTML = newProductContent.innerHTML;
          }

          this.classList.remove('lazy-load');
          this.dispatchEvent(new CustomEvent('product-card-loaded', { bubbles: true }));
        })
        .catch(error => {
          console.error('Error fetching product card template:', error);
        });
    }

    connectedCallback() {
      if (this.classList.contains('lazy-load')) {
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(async (entry) => {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                entry.target.getProductCardTemplate();
              }
            });
          },
          {
            threshold: 0.2,
            rootMargin: '0px'
          }
        );

        this.observer.observe(this);
      }
    }
  })
}

// Prevent wishlist button from navigating to product page
document.addEventListener('click', function(event) {
  // Check if the clicked element is a wishlist button or its child
  const wishlistButton = event.target.closest('wishlist-button-collection .wk-button');
  if (wishlistButton) {
    // Stop the event from bubbling up to the card link
    event.preventDefault();
    event.stopPropagation();
  }
});